module.exports = {
  SIZE_AND_FIT: 'sizeAndFit',
  OFFICE_CULTURE: 'officeCulture',
  SPACE_AND_DESIGN: 'spaceAndDesign',
  WORKPLACE_TRENDS: 'workplaceTrends'
};
